export default "__VITE_ASSET__By6Ox26v__"